import { useQuery } from "@tanstack/react-query";
import { InfluencerService } from "../lib/services/manage.influencer.requests.service";
import {
  INFLUENCER_LIST_QUERY_KEY,
  INFLUENCER_REQUESTS_QUERY_KEY,
} from "@entities/influencer/lib/constants";

export default function useGetInfluencerRequests(
  searchQuery?: string,
  socialMedia?: string[],
  category?: string[],
  agency?: string[],
  status?: string[],
  limit?: number,
  pageNo?: number
) {
  const { data: influencerRequests, isFetching } = useQuery({
    queryKey: [
      ...INFLUENCER_REQUESTS_QUERY_KEY,
      pageNo,
      limit,
      searchQuery,
      socialMedia,
      category,
      agency,
      status,
    ],
    queryFn: async ({ signal }) => {
      return await InfluencerService.getInfluencerRequests(
        signal,
        searchQuery,
        socialMedia,
        category,
        agency,
        status,
        limit,
        pageNo
      );
    },
    placeholderData: (prev) => prev,
  });

  return {
    influencerRequests,
    isFetching,
  };
}
